module.exports = __webpack_public_path__ + "static/img/team-zh-01.35177fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/estate/team/team-zh-01.jpg
// module id = rEoQ
// module chunks = 1